export const IMAGE_SIZES = {
  FULL_WIDTH: '100vw',
  PRODUCT_CARD: '(max-width: 600px) 144px, 163px',
  MINI_PRODUCT_CARD: '(max-width: 600px) 120px, 150px',
  HERO_CARD: '(max-width: 600px) 310px, (max-width: 900px) 338px, 415px',
  AVATAR: '(max-width: 600px) 80px, 120px',
  CONTENT_IMAGE: '(max-width: 600px) 100vw, (max-width: 900px) 80vw, 720px',
  EXPERT_IMAGE: '(max-width: 600px) 275px, 194px',
  SUMMARY_TABLE_CARD: '106px',
} as const;
